// extracted by mini-css-extract-plugin
export default {"emphasized_link":"Main_emphasized_link__oh3KV","subtle_link":"Main_subtle_link__FMjvd","ul":"Main_ul__vr-kC"};